import { mediaQueries } from '@everlywell/leaves';

// 2019 branding colors
// source: http://chir.ag/projects/name-that-color

const colors = {
  // neutrals
  neutral0: '255, 255, 255',
  neutral5: '252, 252, 252',
  neutral10: '245, 245, 245',
  neutral20: '240, 240, 240',
  neutral30: '227, 227, 227',
  neutral40: '221, 221, 221',
  neutral50: '188, 188, 188',
  neutral60: '145, 145, 147',
  neutral80: '72, 72, 72',
  neutral70: '95, 95, 95',
  neutral90: '34, 34, 34',
  neutral100: '0, 0, 0',
  // reds
  red0: '248, 230, 230',
  red5: '254, 209, 209',
  red10: '253, 189, 189',
  red20: '245, 149, 150',
  red30: '243, 107, 107',
  red40: '235, 68, 67',
  red50: '225, 32, 29',
  red60: '211, 4, 0',
  red70: '193, 6, 0',
  red80: '171, 7, 0',
  red90: '147, 9, 0',
  red100: '122, 14, 0',
  // oranges
  orange0: '248, 237, 230',
  orange5: '253, 208, 186',
  orange10: '251, 187, 155',
  orange20: '243, 151, 102',
  orange30: '228, 124, 63',
  orange40: '209, 105, 36',
  orange50: '185, 93, 20',
  orange60: '162, 84, 10',
  orange70: '142, 79, 4',
  orange80: '127, 77, 2',
  orange90: '119, 77, 0',
  orange100: '102, 71, 0',
  // yellows
  yellow0: '246, 243, 233',
  yellow5: '248, 215, 140',
  yellow10: '232, 195, 113',
  yellow20: '207, 166, 63',
  yellow30: '182, 144, 35',
  yellow40: '161, 126, 19',
  yellow50: '143, 112, 10',
  yellow60: '130, 102, 5',
  yellow70: '120, 95, 2',
  yellow80: '112, 89, 1',
  yellow90: '108, 86, 0',
  yellow100: '99, 80, 0',
  // greens
  green0: '235, 241, 240',
  green5: '216, 244, 170',
  green10: '190, 234, 185',
  green20: '154, 207, 95',
  green30: '112, 232, 59',
  green40: '87, 215, 30',
  green50: '123, 181, 71',
  green60: '57, 185, 0',
  green70: '91, 155, 45',
  green80: '33, 96, 8',
  green90: '28, 89, 4',
  green100: '21, 71, 2',
  // teals
  teal0: '230, 255, 248',
  teal5: '177, 242, 225',
  teal10: '128, 229, 205',
  teal20: '71, 200, 174',
  teal30: '40, 173, 149',
  teal40: '22, 148, 128',
  teal50: '12, 128, 112',
  teal60: '7, 113, 99',
  teal70: '4, 101, 90',
  teal80: '3, 93, 83',
  teal90: '2, 88, 79',
  teal100: '2, 69, 62',
  // blues
  blue0: '252, 254, 255',
  blue5: '170, 214, 243',
  blue10: '142, 211, 253',
  blue20: '33, 187, 253',
  blue30: '26, 160, 226',
  blue40: '35, 128, 237',
  blue50: '22, 109, 227',
  blue60: '13, 93, 214',
  blue70: '8, 80, 198',
  blue80: '5, 68, 178',
  blue90: '3, 57, 156',
  blue100: '3, 48, 133',
  // indigos
  indigo100: '59, 22, 84',
  indigo90: '82, 31, 116',
  indigo60: '135, 59, 198',
  indigo80: '103, 40, 147',
  indigo50: '146, 70, 216',
  indigo0: '231, 231, 249',
  indigo5: '221, 207, 254',
  indigo10: '199, 173, 252',
  indigo20: '176, 130, 247',
  indigo30: '164, 103, 240',
  indigo40: '155, 84, 230',
  // violets
  violet0: '244, 232, 250',
  violet5: '246, 192, 249',
  violet10: '245, 146, 247',
  violet20: '243, 91, 237',
  violet30: '237, 57, 220',
  violet40: '227, 35, 201',
  violet50: '215, 21, 181',
  violet60: '199, 13, 161',
  violet70: '178, 7, 140',
  violet80: '153, 4, 118',
  violet90: '126, 3, 96',
  violet100: '97, 2, 73',
};

const fallbackFont = 'Helvetica, Arial, sans-serif';

const fonts = {
  fontFamily: 'AvenirNext-Regular, Helvetica, Arial, sans-serif',
  fontFamilyMd: 'AvenirNext-Medium, Helvetica, Arial, sans-serif',
  fontFamilyDemiBold: 'AvenirNext-DemiBold, Helvetica, Arial, sans-serif',
  fontFamilyBold: 'AvenirNext-Bold, Helvetica, Arial, sans-serif',
};

// 2019 branding fonts (aries)
const ariesFonts = {
  lightFont: `Nexa-Light, Nexa W01 Light, ${fallbackFont}`,
  lightItalicFont: `Nexa-Light-Italic, ${fallbackFont}`,
  regularFont: `Nexa-Regular, Nexa W01 Regular, ${fallbackFont}`,
  regularItalicFont: `Nexa-Regular-Italic, ${fallbackFont}`,
  boldFont: `Nexa-Bold, Nexa W01 Bold, ${fallbackFont}`,
  boldItalicFont: `Nexa-Bold-Italic, ${fallbackFont}`,
  xBoldFont: `Nexa-XBold, ${fallbackFont}`,
  xBoldItalicFont: `Nexa-XBold-Italic, ${fallbackFont}`,
  heavyFont: `Nexa-Heavy, Nexa W01 Heavy, ${fallbackFont}`,
  heavyItalicFont: `Nexa-Heavy-Italic, ${fallbackFont}`,
};

const ariesColors = {
  mineShaft: '34, 34, 34', // #222222 dark gray
  tundora: '72, 72, 72', // #484848 mid gray
  boulder: '118, 118, 118', // #767676 gray
  gray: '136, 136, 136', // #888888 gray
  manatee: '145, 145, 147', // #919193 light gray
  silverChalice: '162, 162, 162', // #a2a2a2 gray button disabled
  altoDark: '216, 216, 216', // #d8d8d8 input gray border
  altoLight: '221, 221, 221', // #dddddd light gray border
  wildSand: '245, 245, 245', // #f5f5f5 light gray background
  silver: '187, 187, 187', // #bbbbbb very light pink
  alabaster: '251, 251, 251', // #fbfbfb white-two
  oceanGreen: '75, 163, 115', // #4ba373 green 1
  pineGreen: '0, 115, 119', // #007377 green 2
  deepTeal: '0, 49, 51', // #003133 dark green 1
  william: '64, 101, 102', // #406566 dark green 2
  teal: '0, 139, 132', // #008b84 green 2bd focused button, hover
  swamp: '0, 32, 33', // #002021
  gallery: '239, 239, 239', // #efefef
  porcelain: '235, 241, 240', // #EBF1F0 lightGreen

  goldenTainoi: '255, 202, 95', // #ffca5f yellow 1
  rajah: '246, 201, 124', // #F6C97C yellow 2

  burntSienna: '239, 119, 91', // #ef775b orange 1
  apricot: '231, 147, 110', // #e7936e orange 2

  sunglo: '229, 101, 117', // #e56575 coral 1
  coral: '233, 127, 114', // #e97f72 coral 2

  curiousBlue: '26, 160, 226', // Curious Blue light blue
  ziggurat: '184, 221, 225', // #B8DDE1 light blue
  lochmara: '0, 131, 204', // #0083cc medium blue
  prussianBlue: '0, 49, 77', // #00314d dark blue
  bahamaBlue: '0, 98, 152', // #006298 cobalt blue text links etc

  mandy: '229, 92, 109', // #e55c6d dark light red
  lavenderBlush: '248, 230, 230', // #fff2f4 light red
  alizarinCrimson: '225, 32, 29', // Alizarin Crimson dark red

  white: '255, 255, 255', // #ffffff white
  romance: '255, 253, 250', // #fffdfa natural white
  black: '0, 0, 0', // #000 black
};

// Just some thoughts of agnostic example vars
const ariesTheme = {
  primaryTextColor: ariesColors.swamp,
  secondaryTextColor: ariesColors.deepTeal,
  tertiaryTextColor: ariesColors.manatee,
  quaternaryTextColor: ariesColors.boulder,
  quinaryTextColor: ariesColors.oceanGreen,
  boxShadowColor: ariesColors.black,
  white: ariesColors.white,
  black: ariesColors.black,

  // General
  primaryColor: ariesColors.white,
  primaryBgColor: ariesColors.oceanGreen,
  primaryHoverBgColor: ariesColors.teal,
  secondaryColor: ariesColors.oceanGreen,
  secondaryBgColor: ariesColors.white,
  tertiaryBgColor: ariesColors.wildSand,
  secondaryBorderColor: ariesColors.oceanGreen,
  secondaryHoverColor: ariesColors.teal,
  secondaryHoverBorderColor: ariesColors.teal,

  // Links
  linkColor: ariesColors.bahamaBlue,
  linkHoverColor: ariesColors.lochmara,
  linkActiveColor: ariesColors.lochmara,
  linkFocusedColor: ariesColors.prussianBlue,
  linkDisabledColor: ariesColors.manatee,

  // Cart
  cartCountBgColor: ariesColors.oceanGreen,
  cartCountColor: ariesColors.white,
  hoverBgColor: ariesColors.teal,
  defaultBorderColor: ariesColors.altoLight,
  cartItemsBgColor: ariesColors.white,
  cartItemPriceColor: ariesColors.swamp,
  cartProductTitleColor: ariesColors.tundora,
  cartDisabledBtnColor: ariesColors.silverChalice,

  // Toggle
  toggleBgColor: ariesColors.manatee,

  // Input
  inputErrorColor: ariesColors.coral,

  // Marker Chart
  markerChartBase: ariesColors.coral,
  markerChartBoundary: ariesColors.silverChalice,
  markerChartBoundaryBadge: ariesColors.tundora,
  markerDetailsCardBgColor: ariesColors.alabaster,

  // Spinner
  spinnerColor: ariesColors.bahamaBlue,

  // DesktopNavItem
  desktopNavTextColor: ariesColors.william,
  desktopNavHoverTextColor: ariesColors.bahamaBlue,
  desktopNavActiveTextColor: ariesColors.bahamaBlue,
  desktopNavFocusTextColor: ariesColors.bahamaBlue,

  // MobileNavItem
  mobileNavTextColor: ariesColors.william,
  mobileNavActiveTextColor: ariesColors.bahamaBlue,
  mobileNavFocusTextColor: ariesColors.prussianBlue,
  mobileNavSubMenuBgColor: ariesColors.wildSand,
  mobileNavSubMenuTextColor: ariesColors.manatee,

  // CountPicker
  countPickerBtnColor: ariesColors.oceanGreen,
  countPickerBorderColor: ariesColors.silver,
  countPickerBgColor: ariesColors.alabaster,

  // Header
  headerBgColor: ariesColors.white,
  navHoverColor: ariesColors.bahamaBlue,

  // Footer
  footerInputBorderColor: ariesColors.manatee,

  // Modal
  modalFooterBgColor: ariesColors.alabaster,

  // Inputs
  primarySuccessColor: ariesColors.oceanGreen,
  secondarySuccessColor: ariesColors.porcelain,
  primaryDangerColor: ariesColors.mandy,
  secondaryDangerColor: ariesColors.lavenderBlush,
  primaryInfoColor: ariesColors.curiousBlue,

  // Buttons
  disabledBgColor: ariesColors.manatee,
  disabledSecondaryBgColor: ariesColors.white,

  colors: ariesColors,
  ...ariesFonts,
  sizes: {
    maxWidth: '1440px',
    maxWidthCentered: '650px',
  },
  disabled: '0.35', // opacity for disabled items
  ...mediaQueries,
};

const resultsTheme = {
  ...ariesTheme,
  textSecondaryColor: ariesColors.tundora,
  spinnerColor: ariesColors.teal,
  badgeRedColor: ariesColors.mandy,
  dashboardBgColor: ariesColors.alabaster,
};

const theme = {
  colors,
  ...fonts,
  sizes: {
    maxWidth: '1440px',
    maxWidthCentered: '650px',
  },
  disabled: '0.2', // opacity for disabled items
  ...mediaQueries,
};

export { colors, fonts, theme, ariesTheme, resultsTheme };
export default theme;
